import React, { Component } from "react";
import {
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  required,
  Navbar,
  Modal,
} from "../../components/CustomComponent.js";
import HolidayCalendar from "../../components/HolidayCalendar";

const pad = (value) => String(value).padStart(2, "0");

export default class Holidays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      loaded: false,

      id: "",
      uid: "",
      name: "",
      date: "",
      weekday: "",

      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, year, month } = this.state;
    let data;
    loading(true);
    let [result] = await Promise.all([
      GET("v1/admin/holidays", {
        data_search: filter_search,
        year_month: year ? `${year}-${String(month).padStart(2, "0")}` : "",
        page: 0,
        page_size: 100000
      }),
    ]);
    if (result?.status) {
      data = result.data;
    }
    this.setState({
      data,
      loaded: true,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, name, weekday, date } = this.state;
    if (!name.trim()) {
      alert("", "warning", "Warning", "Please input Name");
      return;
    }
    if (!date) {
      alert("", "warning", "Warning", "Please input Date");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let body = {
        name,
        weekday,
        date,
      };

      let result = !uid
        ? await POST("v1/admin/holidays", body)
        : await PUT("v1/admin/holidays/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  Delete = async (id, name) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        name
          ? `Do you really want to delete "${name}"?`
          : "Do you really want to delete this item?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await DELETE("v1/admin/holidays/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  // Weekday name for the API. Built from the date parts instead of parsing the
  // string, so the local timezone can never shift it to the day before.
  WeekdayOf = (value) => {
    const [year, month, day] = String(value || "").slice(0, 10).split("-").map(Number);
    if (!year || !month || !day) return "";
    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      weekday: "long",
    });
  };
  // Opens the create modal on the day that was clicked in the calendar.
  OpenCreate = (date) => {
    this.setState({
      id: "",
      uid: "",
      name: "",
      date: date || "",
      weekday: this.WeekdayOf(date),
      modal_create: true,
    });
  };
  OpenUpdate = (item) => {
    const date = String(item.date || "").slice(0, 10);
    this.setState({
      ...item,
      date,
      weekday: item.weekday || this.WeekdayOf(date),
      modal_update: true,
    });
  };
  // delta -1 / +1 steps a month, 0 jumps back to the current month.
  ChangeMonth = (delta) => {
    const now = new Date();
    if (!delta) {
      this.setState(
        { year: now.getFullYear(), month: now.getMonth() + 1 },
        () => this.Get(1),
      );
      return;
    }
    const { year, month } = this.state;
    const base = new Date(year || now.getFullYear(), (month || now.getMonth() + 1) - 1 + delta, 1);
    this.setState(
      { year: base.getFullYear(), month: base.getMonth() + 1 },
      () => this.Get(1),
    );
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,
      name,
      weekday,
      date,

      month,
      year,
    } = this.state;
    const now = new Date();
    const view_year = year || now.getFullYear();
    const view_month = month || now.getMonth() + 1;
    const rows = Array.isArray(data) ? data : [];
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const heroMonth = monthNames[view_month - 1]?.slice(0, 3).toUpperCase() || "—";
    const closeModal = () => this.setState({ modal_create: false, modal_update: false });
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Configuration</div>
                <div className="ar-title">Holiday Management</div>
                <div className="ar-subtitle">
                  Manage holidays that hold broker withdrawals.
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-gold holidays.create"
                  onClick={() => {
                    this.OpenCreate("");
                  }}
                >
                  <span className="icon me-2">{""}</span>Create Holiday
                </button>
                <div className="text-end ms-2 d-none d-md-block">
                  <div className="ar-year">
                    {heroMonth}
                    <span className="ar-year-small"> {view_year}</span>
                  </div>
                  <div className="ar-year-caption justify-content-end">
                    {rows.length} holiday{rows.length === 1 ? "" : "s"}
                  </div>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{""}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field ar-filter-field-search">
<span className="ar-filter-label">Search</span>
<input
                type="text"
                className="form-control wpx-250"
                placeholder="Search holiday name..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Month</span>
<input
                type="month"
                className="form-control wpx-180"
                onChange={(e) => {
                  this.setState(
                    {
                      year: e.target.value
                        ? Number(e.target.value.split("-")[0])
                        : now.getFullYear(),
                      month: e.target.value
                        ? Number(e.target.value.split("-")[1])
                        : now.getMonth() + 1,
                    },
                    () => {
                      this.Get(1);
                    },
                  );
                }}
                value={`${view_year}-${pad(view_month)}`}
              />
</div>
<div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() => {
                  this.setState(
                    {
                      filter_search: "",
                      month: now.getMonth() + 1,
                      year: now.getFullYear(),
                    },
                    () => this.Get(1),
                  );
                }}
              >
                Reset
              </button>
              </div>
</div>
</div>
          </div>

          {/* CALENDAR */}
          <div className="ar-table-card mb-3">
            <HolidayCalendar
              list={data}
              month={view_month}
              year={view_year}
              onAdd={(value) => this.OpenCreate(value)}
              onEdit={(item) => this.OpenUpdate(item)}
              onDelete={(item) => this.Delete(item.uid, item.name)}
              onMonthChange={(delta) => this.ChangeMonth(delta)}
            />
            <div className="hc-footer">
              <span className="me-3">
                <span className="hc-legend-swatch" />
                Holiday
              </span>
              <span className="me-3">
                <span className="hc-legend-today" />
                Today
              </span>
              <span className="hc-footer-hint">
                Click a day to add a holiday · click a holiday to edit · use the trash icon to delete
              </span>
            </div>
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={closeModal}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">
                {modal_create ? "New holiday" : "Edit holiday"}
              </div>
              <h5 className="fw-bold mb-0">
                {modal_create ? "Create" : modal_update ? "Update" : ""} Holiday
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Date
              </div>
              <label className="pr-label">Date{required}</label>
              <div className="pu-password">
                <input
                  type="date"
                  className="form-control pr-input"
                  placeholder="Date..."
                  maxLength={10}
                  value={date}
                  onChange={(e) => {
                    this.setState({
                      date: e.target.value,
                      weekday: this.WeekdayOf(e.target.value),
                    });
                  }}
                />
                {weekday ? (
                  <span className="hc-weekday-chip">
                    <span className="icon me-2">{""}</span>
                    {weekday}
                  </span>
                ) : null}
              </div>
              <div className="pu-hint">
                Withdrawals for brokers are held on this date.
              </div>
            </div>
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Holiday
              </div>
              <label className="pr-label">Name{required}</label>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="e.g. Songkran Festival"
                onChange={(e) => {
                  this.setState({ name: e.target.value });
                }}
                value={name}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={closeModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
